module.exports = __webpack_public_path__ + "slick.f97e3bbf73254b011209.svg";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/assets/slick/fonts/slick.svg
// module id = ../../../../../src/assets/slick/fonts/slick.svg
// module chunks = styles